import {FC} from 'react';
import {View, StyleSheet, Text} from '@react-pdf/renderer';
import Table from './Table';
import {IPDFPCleanUp} from '../../../models/pdfReport';

const styles = StyleSheet.create({
    empty: {
        padding: 8,
        fontFamily: 'Roboto',
        fontSize: 14,
    },
    categorySection: {
        marginTop: 12,
    },
});

interface IProps {
    data: IPDFPCleanUp;
}

const LocationCollectedCategories: FC<IProps> = ({
    data: {
        collectedCategories,
    },
}) => {
    const hasCategories = collectedCategories.length > 0;

    return (
        <View style={{marginTop: 24}}>
            <Table
                title="COLLECTED ITEMS BY CATEGORY"
                titleInfo={hasCategories ? `${collectedCategories.length} categories` : 'No items'}
                mode="grid"
                rows={[]}
            />
            
            {collectedCategories.map((category) => (
                <View key={category.id} style={styles.categorySection}>
                    <Table
                        title={category.name.toUpperCase()}
                        titleInfo={`${category.items.reduce((sum, item) => sum + item.amount, 0)} items`}
                        mode="grid"
                        rows={category.items.map((item) => ({
                            title: item.name,
                            info: `${item.amount}`,
                        }))}
                    />
                </View>
            ))}

            {!hasCategories && (
                <Text style={styles.empty}>No waste category items were reported</Text>
            )}
        </View>
    );
};

export default LocationCollectedCategories;